const Menu = [
  {
    name: 'Bảng tin',
    active: 'the-news',
    link: '/my-business/dashboard',
    icon: 'vtd vtd-home',
    subMenu: []
  },
  {
    name: 'Thông báo',
    active: 'my-business-announcements',
    link: '/my-business/announcements',
    icon: 'vtd vtd-notification',
    subMenu: []
  },
  {
    name: 'Quản lý đơn hàng',
    active: 'my-business-orders',
    link: '/my-business/orders',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Quản lý sản phẩm',
    active: 'manage-product',
    link: '/my-business/products',
    icon: 'vtd vtd-product',
    subMenu: [
      {
        name: 'Danh sách sản phẩm',
        active: '',
        link: '/my-business/products',
        icon: 'vtd vtd-notification'
      },
      {
        name: 'Thêm sản phẩm',
        active: '',
        link: '/my-business/post-product',
        icon: 'vtd vtd-notification'
      }
    ]
  },
  {
    name: 'Gửi nhu cầu',
    active: 'post-demand',
    link: '/my-business/post-demand',
    icon: 'vtd vtd-flag',
    subMenu: []
  },
  {
    name: 'Quản lý nhu cầu',
    active: 'need-offer',
    link: '/my-business/demands',
    icon: 'vtd vtd-need-offer',
    subMenu: []
  },
  {
    name: 'Yêu cầu sản phẩm',
    active: 'my-requests',
    link: '/my-business/requests',
    icon: 'vtd vtd-menu',
    subMenu: []
  },
  {
    name: 'Thống kê',
    active: 'my-business-stats',
    link: '/my-business/stats',
    icon: 'vtd vtd-thong-ke',
    subMenu: []
  },
  {
    name: 'Hội chợ triển lãm',
    active: 'business-fair',
    link: '/my-business/fair',
    icon: 'vtd vtd-flag',
    subMenu: []
  },
  {
    name: 'Thông tin doanh nghiệp',
    active: 'profile',
    link: '/my-business/edit',
    icon: 'vtd vtd-thong-tin-doanh-nghiep',
    subMenu: []
  },
  {
    name: 'Thông tin thanh toán',
    active: 'payments',
    link: '/my-business/payments',
    icon: 'vtd vtd-credit-card',
    subMenu: []
  }
];

export {Menu};



// WEBPACK FOOTER //
// ./components/layouts/business/menu/menu.js